export default { notification: (state) => state.notification };
